import React, { useState } from 'react';
import toast from 'react-hot-toast';

const API = 'https://apexmedtech-backend-production.up.railway.app/api';

export default function ExportButton({ type, label, params = {} }) {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const query = new URLSearchParams(params).toString();
      const url   = `${API}/export/${type}${query ? '?' + query : ''}`;

      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      if (!res.ok) throw new Error('Export échoué');

      const blob = await res.blob();
      const link = document.createElement('a');
      link.href  = URL.createObjectURL(blob);
      link.download = `${type}_lomed_${new Date().toISOString().slice(0,10)}.csv`;
      link.click();
      URL.revokeObjectURL(link.href);
      toast.success(`Export ${label} téléchargé ✅`);
    } catch(err) {
      toast.error('Erreur lors de l\'export');
    } finally { setLoading(false); }
  };

  return (
    <button onClick={handleExport} disabled={loading} style={{
      display:'flex', alignItems:'center', gap:6,
      background: loading ? '#94a3b8' : '#fff',
      color: loading ? '#fff' : '#0B3D6E',
      border:'1px solid #e2e8f0', padding:'7px 14px',
      borderRadius:8, fontSize:12, fontWeight:600, cursor:'pointer',
      whiteSpace:'nowrap', transition:'all 0.2s'
    }}
      onMouseEnter={e=>{ if(!loading){ e.currentTarget.style.background='#E6F1FB'; e.currentTarget.style.borderColor='#0B3D6E'; }}}
      onMouseLeave={e=>{ if(!loading){ e.currentTarget.style.background='#fff'; e.currentTarget.style.borderColor='#e2e8f0'; }}}>
      {loading ? '⏳' : '⬇'} {loading ? 'Export...' : label}
    </button>
  );
}

